/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './user-management.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../shared/ui/mobile-header/mobile-header.component.ngfactory';
import * as import3 from '../../../app/shared/ui/mobile-header/mobile-header.component';
import * as import4 from '@angular/router';
import * as import5 from '../../../app/booking-management/booking-header/booking-header.service';
import * as import6 from './user-header/user-header.component.ngfactory';
import * as import7 from '../../../app/user-management/user-header/user-header.component';
import * as import8 from '../../../app/shared/router/linkhelper';
import * as import9 from '@angular/material';
import * as import10 from './user-filter/user-filter.component.ngfactory';
import * as import11 from '../../../app/user-management/user-filter/user-filter.component';
import * as import12 from '../../../app/user-management/user-management.component';
import * as import13 from './user-list/user-list.component.ngfactory';
import * as import14 from '../../../app/user-management/user-list/user-list.component';
import * as import15 from '../../../app/api/user.service';
import * as import16 from '../../../app/notification/notification.service';
import * as import17 from '../../../app/spinner/spinner.service';
import * as import18 from '../../../app/shared/role-permission/role-permission';
import * as import19 from '../../../app/shared/sub-organisation-filter/sub-organisation-filter.service';
const styles_UserManagementComponent:any[] = [import0.styles];
export const RenderType_UserManagementComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_UserManagementComponent,
  data: {}
}
);
export function View_UserManagementComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-mobile-header',[
      [
        'backLink',
        '/booking-management'
      ]
      ,
      [
        'title',
        'MANAGE USERS'
      ]

    ]
    ,(null as any),(null as any),(null as any),import2.View_MobileHeaderComponent_0,import2.RenderType_MobileHeaderComponent)),
    import1.ɵdid(49152,(null as any),0,import3.MobileHeaderComponent,[
      import4.Router,
      import5.BookingHeaderService
    ]
    ,{
      title: [
        0,
        'title'
      ]
      ,
      backLink: [
        1,
        'backLink'
      ]
      ,
      showBackLink: [
        2,
        'showBackLink'
      ]

    }
    ,(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),5,'section',[[
        'id',
        'submenu'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(16777216,(null as any),(null as any),2,'app-user-header',[[
        'id',
        'main-submenu-links'
      ]
    ],(null as any),(null as any),(null as any),import6.View_UserHeaderComponent_0,import6.RenderType_UserHeaderComponent)),
    import1.ɵdid(49152,(null as any),0,import7.UserHeaderComponent,[
      import8.LinkAuth,
      import4.Router,
      import9.MdDialog,
      import1.ViewContainerRef
    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n\n'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),7,'section',[[
        'id',
        'page-manage-users'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-user-filter',([] as any[]),(null as any),(null as any),(null as any),import10.View_UserFilterComponent_0,import10.RenderType_UserFilterComponent)),
    import1.ɵdid(114688,(null as any),0,import11.UserFilterComponent,([] as any[]),(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-user-list',([] as any[]),(null as any),[
      [
        (null as any),
        'onPageEmit'
      ]
      ,
      [
        (null as any),
        'onDeleteUser'
      ]
      ,
      [
        (null as any),
        'onResetPass'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import12.UserManagementComponent = v.component;
      if (('onPageEmit' === en)) {
        const pd_0:any = ((<any>co.onPageEmit($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('onDeleteUser' === en)) {
        const pd_1:any = ((<any>co.onDeleteUser($event)) !== false);
        ad = (pd_1 && ad);
      }
      if (('onResetPass' === en)) {
        const pd_2:any = ((<any>co.onResetPassword($event)) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },import13.View_UserListComponent_0,import13.RenderType_UserListComponent)),
    import1.ɵdid(114688,(null as any),0,import14.UserListComponent,[
      import8.LinkAuth,
      import15.UserService,
      import16.NotificationServiceBus
    ]
    ,{
      userList: [
        0,
        'userList'
      ]
      ,
      p: [
        1,
        'p'
      ]
      ,
      totalItems: [
        2,
        'totalItems'
      ]

    }
    ,{
      onResetPass: 'onResetPass',
      onPageEmit: 'onPageEmit',
      onDeleteUser: 'onDeleteUser'
    }
    ),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import12.UserManagementComponent = v.component;
    const currVal_0:any = 'MANAGE USERS';
    const currVal_1:any = '/booking-management';
    const currVal_2:any = true;
    ck(v,1,0,currVal_0,currVal_1,currVal_2);
    ck(v,13,0);
    const currVal_3:any = co.users;
    const currVal_4:any = co.page;
    const currVal_5:any = co.totalItems;
    ck(v,16,0,currVal_3,currVal_4,currVal_5);
  },(null as any));
}
function View_UserManagementComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(16777216,(null as any),(null as any),1,'app-admin',([] as any[]),(null as any),(null as any),(null as any),View_UserManagementComponent_0,RenderType_UserManagementComponent)),
    import1.ɵdid(180224,(null as any),0,import12.UserManagementComponent,[
      import17.SpinnerService,
      import16.NotificationServiceBus,
      import15.UserService,
      import18.RolePermission,
      import19.SubOrganisationFilterService,
      import9.MdDialog,
      import1.ViewContainerRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const UserManagementComponentNgFactory:import1.ComponentFactory<import12.UserManagementComponent> = import1.ɵccf('app-admin',import12.UserManagementComponent,View_UserManagementComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/user-management/user-management.component.ngfactory.ts